import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModelSelectionUndoState } from '../ModelSelectionPage';
import { StoreState } from '../../../store/store';
import { aeTitleRuleActionUpdated, aeTitleRuleRemoved, contouringSelectors } from '../../../store/contouring/contouringSlice';
import { makeSelectFormValidationErrorsForAeTitleRule } from '../../../store/contouring/contouringSelectors';
import { ModelType } from '../../../store/global-types/customization-types';
import AeTitleRuleForm from '../AeTitleRuleForm';
import { AETITLE_PREFIX_CONTOUR } from '../../../store/contouring/contouring-types';



interface ContourAeTitleRuleProps {
    aeTitleRuleId: string,
    runningNumber: number,
    isLastRule: boolean,
    setUndoState: (undoState: ModelSelectionUndoState) => void,
    isUndoDisabled?: boolean,
}

const ContourAeTitleRule = (props: ContourAeTitleRuleProps) => {
    const { aeTitleRuleId, runningNumber, isLastRule, setUndoState, isUndoDisabled, } = props;

    const dispatch = useDispatch();

    const aeTitleRule = useSelector((state: StoreState) => contouringSelectors.selectAeTitleRuleById(state, aeTitleRuleId));
    const validationError = useSelector((state: StoreState) => contouringSelectors.selectCustomizationValidationError(state, aeTitleRuleId));
    const selectFormValidationErrorsForRule = makeSelectFormValidationErrorsForAeTitleRule();
    const formValidationErrors = useSelector((state: StoreState) => selectFormValidationErrorsForRule(state, aeTitleRuleId));

    const handleAeTitleActionChanged = useCallback((action: string) => {
        dispatch(aeTitleRuleActionUpdated({ id: aeTitleRuleId, action }));
    }, [dispatch, aeTitleRuleId]);


    const handleAeTitleRemoved = useCallback(() => {
        dispatch(aeTitleRuleRemoved(aeTitleRuleId));
    }, [dispatch, aeTitleRuleId]);


    // don't render anything if we don't have a valid object
    if (aeTitleRule === undefined) {
        return null;
    }

    return (
        <AeTitleRuleForm
            aeTitleRule={aeTitleRule}
            prefix={AETITLE_PREFIX_CONTOUR}
            modelType={ModelType.Contouring}
            onAeTitleRuleActionUpdated={handleAeTitleActionChanged}
            onAeTitleRuleRemoved={handleAeTitleRemoved}
            runningNumber={runningNumber}
            isLastRule={isLastRule}
            setUndoState={setUndoState}
            validationError={validationError}
            formValidationErrors={formValidationErrors}
            isUndoDisabled={isUndoDisabled}
         />
    );
}

export default ContourAeTitleRule;
